import React from "react";
import { useTranslation } from "react-i18next";

import { MemberAvatar } from "@common/memberAvatar";
import { FolderIcon } from "@common/folderIcon";
import { Props } from "./types";
import { IndicatorsList } from "./indicatorsList";
import styles from "./styles.scss";

function Report(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.report} data-testid="zones-project-report">
      <div className={styles.nameBox}>
        <FolderIcon className={styles.folderIcon} />
        <h3 className={styles.projectName}>{props.project.name}</h3>
        <span className={styles.separator}>&gt;</span>
        <p className={styles.reportName}>{props.report.name}</p>
      </div>
      <div className={styles.row}>
        <p className={styles.label}>{t("zonesPage.reportsPage.author")} :</p>
        <div className={styles.author}>
          <div className={styles.authorAvatar}>
            <MemberAvatar avatarUrl="" name={props.report.author} />
          </div>
          <p className={styles.authorName}>{props.report.author}</p>
        </div>
      </div>
      <div className={styles.row}>
        <p className={styles.label}>
          {t("zonesPage.reportsPage.submissionDate")} :
        </p>
        <p className={styles.text}>
          {new Date(props.report.submissionDate).toLocaleDateString()}
        </p>
      </div>
      <div className={styles.row}>
        <p className={styles.label}>{t("zonesPage.reportsPage.zone")} :</p>
        <p className={styles.text}>{props.zone.name}</p>
      </div>
      <div className={styles.indicators}>
        <IndicatorsList
          indicators={props.report.fields.filter(
            ({ type }) => type === "indicator",
          )}
        />
      </div>
    </div>
  );
}

export { Report };
